import { CHECKOUT_FIELD_MARGIN } from '../common/constants/checkoutViewport';
import type { CheckoutVisualViewport, VerticalBounds } from '../interfaces/checkoutViewport.interface';

export function getCheckoutViewport(
  fallbackHeight: number,
  visualViewport?: CheckoutVisualViewport | null,
): VerticalBounds {
  const top = Math.max(0, visualViewport?.offsetTop ?? 0);
  return {
    top,
    bottom: top + (visualViewport?.height || fallbackHeight),
  };
}

export function getCheckoutFocusSpace(
  clientHeight: number,
  contentHeight: number,
  submitOffsetTop: number,
  currentSpace: number,
): number {
  const belowSubmitTop = contentHeight - currentSpace - submitOffsetTop;

  return Math.max(0, clientHeight - CHECKOUT_FIELD_MARGIN - belowSubmitTop);
}

export function getCheckoutSectionScroll(sectionTop: number, viewportTop: number): number {
  return sectionTop - viewportTop - CHECKOUT_FIELD_MARGIN;
}

export function getCheckoutFieldScroll(
  field: VerticalBounds,
  viewport: VerticalBounds,
  button?: VerticalBounds | null,
): number {
  const top = viewport.top + CHECKOUT_FIELD_MARGIN;
  const bottom = viewport.bottom - CHECKOUT_FIELD_MARGIN;
  if (bottom <= top) return 0;

  const fieldToButtonHeight = button && button.bottom >= field.bottom ? button.bottom - field.top : 0;
  if (fieldToButtonHeight > bottom - top && fieldToButtonHeight <= viewport.bottom - viewport.top) {
    return field.top - viewport.top;
  }

  const targetBottom = button && fieldToButtonHeight && fieldToButtonHeight <= bottom - top
    ? button.bottom
    : field.bottom;

  if (field.top < top || targetBottom - field.top > bottom - top) return field.top - top;
  return Math.max(0, targetBottom - bottom);
}
